import { render, staticRenderFns } from "./LoonitySidebar.vue?vue&type=template&id=785bd5c0&"
import script from "./LoonitySidebar.vue?vue&type=script&lang=js&"
export * from "./LoonitySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports